export const SepratePrice = (price, lang) => {
    var str = price.toString()
    var objRegex = new RegExp('(-?[0-9]+)([0-9]{3})');

    while (objRegex.test(str)) {
        str = str.replace(objRegex, '$1,$2');
    }
    if (lang === "ar")
        return str + ' دولار ';
    else
        return str + ' تومان ';
}
export const SepratePrice2 = (price, lang) => {
    price = price.replace(/^\D+/g, '');
    var objRegex = new RegExp('(-?[0-9]+)([0-9]{3})');

    while (objRegex.test(price)) {
        price = price.replace(objRegex, '$1,$2');
    }
    if (lang === "ar")
        return price + ' دولار ';
    else
        return price + ' تومان ';
}